import { RefObject, useLayoutEffect, useState } from 'react';

// Starts at 0 until the first measurement so callers can skip layout work.
export const useElementWidth = (ref: RefObject<HTMLElement>): number => {
  const [width, setWidth] = useState(0);

  useLayoutEffect(() => {
    const element = ref.current;

    if (!element) {
      return;
    }

    setWidth(element.clientWidth);

    const observer = new ResizeObserver(([entry]) => {
      setWidth(entry.target.clientWidth);
    });

    observer.observe(element);

    return () => observer.disconnect();
  }, [ref]);

  return width;
};
